import type { Ship } from '@fleetduel/shared'
import { colIndex } from '@fleetduel/shared'
import { SHIP_ASSETS } from '../../assets/index.js'
import { CELL_SIZE } from './Cell.js'

interface ShipOverlayProps {
  ships: Ship[]
  headerOffsetLeft: number
  headerOffsetTop: number
}

/** Renders ship SVGs as absolute-positioned images spanning their cells */
export function ShipOverlay({ ships, headerOffsetLeft, headerOffsetTop }: ShipOverlayProps) {
  return (
    <>
      {ships.map((ship) => {
        const ci = colIndex(ship.origin.col)
        const ri = ship.origin.row - 1 // row is 1-based
        const src = SHIP_ASSETS[ship.type]

        const isVertical = ship.direction === 'vertical'
        // Ship SVGs are drawn horizontally: width = size * 64, height = 64
        const shipWidth = ship.size * CELL_SIZE
        const shipHeight = CELL_SIZE

        // Position relative to the grid container (accounting for headers)
        const left = headerOffsetLeft + ci * CELL_SIZE
        const top = headerOffsetTop + ri * CELL_SIZE

        if (isVertical) {
          // Rotate 90deg clockwise, transform-origin at top-left corner
          return (
            <img
              key={`${ship.type}-${ship.origin.col}${ship.origin.row}`}
              src={src}
              alt={ship.type}
              draggable={false}
              style={{
                position: 'absolute',
                left,
                top,
                width: shipWidth,
                height: shipHeight,
                transformOrigin: '0 0',
                transform: `rotate(90deg) translateY(-${CELL_SIZE}px)`,
                pointerEvents: 'none',
                zIndex: 1,
              }}
            />
          )
        }

        return (
          <img
            key={`${ship.type}-${ship.origin.col}${ship.origin.row}`}
            src={src}
            alt={ship.type}
            draggable={false}
            style={{
              position: 'absolute',
              left,
              top,
              width: shipWidth,
              height: shipHeight,
              pointerEvents: 'none',
              zIndex: 1,
            }}
          />
        )
      })}
    </>
  )
}
